module.exports = __webpack_public_path__ + "img/team-member-06.bf91cb90.jpg";